export const BatchGatewayTransferStructuredListTableHeader = () => {
  return (
    <div className="cds--structured-list-thead">
      <div className="cds--structured-list-row cds--structured-list-row--header-row">
        <div className="cds--structured-list-th font-ctm--semibold">#</div>

        <div className="cds--structured-list-th font-ctm--semibold"></div>

        <div className="cds--structured-list-th">Amount</div>

        <div className="cds--structured-list-th">Beneficiary Id</div>

        <div className="cds--structured-list-th font-ctm--semibold">
          Merch. Code
        </div>

        <div className="cds--structured-list-th font-ctm--semibold">
          Merch. Name
        </div>

        <div className="cds--structured-list-th font-ctm--semibold ">
          Gateway
        </div>

        <div className="cds--structured-list-th">Reference</div>

        <div className="cds--structured-list-th">Email</div>

        <div className="cds--structured-list-th">
          <span className="font-ctm--bold">Actions</span>
        </div>

        {/* Delete Button */}
        {/* <div className="cds--structured-list-th" /> */}
      </div>
    </div>
  );
};
